import { FC, useEffect, useState } from "react";
import { Autocomplete, IconButton, FormLabel, Button, Grid, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography, TablePagination, Checkbox, Divider } from '@mui/material';
import { useUserStore } from "../../hooks/UseUserStore";
import { typeUsers } from "../../types/slices/userType";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { PermissionByUserType } from "../../types/slices/permissionType";
import { usePermissionStore } from "../../hooks/usePermissionStore";
import { ApiStatus } from "../../types/api/status";

const columns = [
    { type: 'text', field: 'n', label: 'N°', align:'center' },
    { type: 'text', field: 'description', label: 'Permiso', align:'center' },
    { type: 'detail', field: 'detail', label: 'Estado', align:'center' },
];

type DataTable = {
    id:number
    n:number
    description:string
    status:number
}

export const PermissionsByUserType:FC = () => {

    const { typeUsers, getUserType } = useUserStore()
    const { status: statusPermission, permissions, getPermissionByUserType, getPermissions, editPermissionByUserType } = usePermissionStore()

    const [selectedUserType, setSelectedUserType] = useState<typeUsers|null>(null)
    const [permission, setPermission] = useState<PermissionByUserType|null>(null)
    const [dataTable, setDataTable] = useState<DataTable[]>([])

    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        getDataApi()
    },[])

    useEffect(() => {
        getPermisionByUserType()
    },[selectedUserType])

    useEffect(() => {
        setDataTableInfo()
    },[permission, permissions])
    
    const getDataApi = async () => {
        setLoading(true)
        const response = await getUserType()
        await getPermissions()
        if (response.length > 0 ) setSelectedUserType(response[0] || null)
        setLoading(false)
    }

    const getPermisionByUserType = async () => {
        if (!selectedUserType) return

        const response = await getPermissionByUserType({ iduser_type: selectedUserType.id })
        if (response.length > 0 ) setPermission(response[0] || null)
    }

    const setDataTableInfo = () => {
        if (!permission || permissions.length === 0) return 

        const data:DataTable[] = permissions.map((row, index) => ({ 
            id: row.id,
            n: index + 1,
            description: row.description,
            status: permission.permissions.includes(row.id) ? 1: 0
        }))
        setDataTable(data || [])
    }

    const changeStatus = async (rowSelected) => {
        if (!permission) return
        let relation 
        if (rowSelected.status === 1) {
            relation = permission.permissions.filter(number => number !== rowSelected.id)
        } else {
            relation = [...permission.permissions, rowSelected.id]
        }
        const response = await editPermissionByUserType(permission?.id, { permissions: relation, iduser_type: selectedUserType?.id })
        if (response === true) getPermisionByUserType()
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                <Typography variant='h6' component='h1' gutterBottom color='#808080' className="tittle" sx={{ mt: 1, ml:1 , fontWeight:600, textAlign: 'center'}}>
                    CONFIGURACION DE PERMISOS POR TIPO DE USUARIO
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <FormLabel>Tipo de usuario:</FormLabel>
                {
                    loading
                    ?
                    <Skeleton variant="rectangular" width="100%" height={40} />
                    :
                    <Autocomplete
                        disablePortal
                        id="combo-box-user-type"
                        value={selectedUserType}
                        options={typeUsers || []}
                        getOptionLabel={(option) => option.name || ""}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        fullWidth
                        renderInput={(params) => <TextField {...params} size="small" />}
                        onChange={(e, newValue) => {
                            setSelectedUserType(newValue);
                        }}
                    />
                }
            </Grid>
            <Grid item xs={12}>
                <CustomTable
                    columns={columns} 
                    loading={statusPermission === ApiStatus.FETCHING}
                    rows={dataTable || []}
                    onRowClick={() => {}}
                    hasOptions
                    onSwitch={changeStatus}
                    dense
                    withoutPagination
                />
            </Grid>
        </Grid>
    )
}